import { useEffect } from "react";
import childSafetyMd from "../content/policies/child-safety.md?raw";
import { renderMarkdown } from "../lib/markdown";
import { EditorialPage } from "../components/editorial";
import Navbar from "../components/Navbar";
import StoryPageHero from "../components/story/StoryPageHero";

// Google Play's Child Safety Standards policy requires social/dating apps to
// publish their CSAE standards at a publicly reachable URL and to point the
// Play Console declaration at it. That is what this page is for: it is a
// compliance surface first and marketing surface never, so the body keeps the
// same plain styling as the other policy pages.

export default function ChildSafetyPage() {
  useEffect(() => {
    document.title = "Child Safety Standards | LetsLoop";
  }, []);

  return (
    <>
      <Navbar />
      <EditorialPage>
        <StoryPageHero
          kicker="child safety"
          title={<>Zero tolerance. Adults only.</>}
          marks={[
            {
              name: "loop",
              size: 58,
              rotate: 8,
              className: "right-[8%] top-[30%] text-teal/25",
            },
          ]}
        />

        <article className="relative max-w-3xl mx-auto px-4 md:px-6 pt-4 pb-16 md:pb-24">
          {renderMarkdown(childSafetyMd)}
        </article>
      </EditorialPage>
    </>
  );
}
